var styles = {
  "iconWrapper": "pb-Icon__iconWrapper",
  "scaled": "pb-Icon__scaled",
  "inline": "pb-Icon__inline",
  "Icon": "pb-Icon__Icon",
  "Icon--scaled": "pb-Icon__Icon--scaled"
};
export default styles;